import { NavLink, useLocation } from 'react-router-dom';
import {
  FiLogOut,
  FiUsers,
  FiSettings,
  FiPackage,
  FiGrid,
  FiLayers,
  FiHome,
  FiBox,
  FiChevronDown,
  FiChevronUp,
  FiBarChart2,
  FiPercent,
} from 'react-icons/fi';
import { useState, useEffect } from 'react';
import useAuth from '../../../hooks/useAuth';

const Sidebar = ({ slug }) => {
  const location = useLocation();
  const [productMenuOpen, setProductMenuOpen] = useState(false);
  const { signOutUser, user } = useAuth();

  useEffect(() => {
    if (
      location.pathname.startsWith(`/admin/${slug}/produits`) ||
      location.pathname.startsWith(`/admin/${slug}/produits-promo`)
    ) {
      setProductMenuOpen(true);
    }
  }, [location.pathname, slug]);

const handleLogout = async () => {
  console.group('[Sidebar] 🔒 Déconnexion déclenchée');
  console.log('[Sidebar] ➡️ Utilisateur courant :', user);
  console.log('[Sidebar] ➡️ Token sessionStorage:', sessionStorage.getItem('access_token'));
  console.log('[Sidebar] ➡️ Client ID sessionStorage:', sessionStorage.getItem('client_id'));

  await signOutUser('Sidebar logout');

  console.log('[Sidebar] ✅ Token après déconnexion:', sessionStorage.getItem('access_token'));
  console.log('[Sidebar] ✅ Client ID après déconnexion:', sessionStorage.getItem('client_id'));
  console.log('[Sidebar] ✅ Déconnexion terminée');
  console.groupEnd();
};


  const mainLinks = [
    { to: `/admin/${slug}`, label: 'Tableau de Bord', icon: <FiHome size={20} /> },
    { to: `/admin/${slug}/utilisateurs`, label: 'Utilisateurs', icon: <FiUsers size={20} /> },
    { to: `/admin/${slug}/commandes`, label: 'Commandes', icon: <FiPackage size={20} /> },
    { to: `/admin/${slug}/categories`, label: 'Catégories', icon: <FiGrid size={20} /> },
    { to: `/admin/${slug}/sous-categories`, label: 'Sous-catégories', icon: <FiLayers size={20} /> },
  ];

  const productLinks = [
    { to: `/admin/${slug}/produits`, label: 'Liste des Produits', icon: <FiBox size={16} /> },
    { to: `/admin/${slug}/produits-promo`, label: 'Produits en Promo', icon: <FiPercent size={16} /> },
  ];

  const bottomLinks = [
    { to: `/admin/${slug}/rapports`, label: 'Rapports', icon: <FiBarChart2 size={20} /> },
    { to: `/admin/${slug}/parametres`, label: 'Paramètres', icon: <FiSettings size={20} /> },
  ];

  return (
    <aside className="h-screen w-64 bg-paragaia flex flex-col fixed shadow-lg overflow-hidden">
    <NavLink
      to={`/admin/${slug}`}
      className="flex items-center space-x-3 p-6 border-b border-paragaiaLight hover:bg-paragaiaLight transition"
    >
      <img src="/assets/favicon.png" alt="Logo" className="w-10 h-10" />
      <span className="text-2xl font-bold text-white tracking-wide">Admin Panel</span>
    </NavLink>


      <nav className="flex-1 overflow-y-auto p-4 space-y-3">
        {mainLinks.map(link => (
          <NavLink
            key={link.to}
            to={link.to}
            className={({ isActive }) =>
              `flex items-center space-x-3 p-3 rounded-lg text-white text-base font-medium transition-all duration-200 ${
                isActive
                  ? 'bg-paragaiaLight text-paragaia'
                  : 'hover:bg-paragaiaLight hover:text-paragaia'
              }`
            }
          >
            {link.icon}
            <span>{link.label}</span>
          </NavLink>
        ))}

        <div>
          <button
            onClick={() => setProductMenuOpen(!productMenuOpen)}
            className="flex items-center justify-between w-full p-3 rounded-lg text-white text-base font-medium transition-all duration-200 hover:bg-paragaiaLight hover:text-paragaia"
          >
            <div className="flex items-center space-x-3">
              <FiBox size={20} />
              <span>Produits</span>
            </div>
            {productMenuOpen ? <FiChevronUp size={16} /> : <FiChevronDown size={16} />}
          </button>

          {productMenuOpen && (
            <div className="pl-6 mt-2 space-y-2">
              {productLinks.map(link => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  className={({ isActive }) =>
                    `flex items-center space-x-2 px-3 py-1 rounded text-sm font-medium transition duration-150 ${
                      isActive
                        ? 'bg-white text-paragaia font-semibold'
                        : 'text-white hover:text-paragaiaLight'
                    }`
                  }
                >
                  {link.icon}
                  <span>{link.label}</span>
                </NavLink>
              ))}
            </div>
          )}
        </div>

        {bottomLinks.map(link => (
          <NavLink
            key={link.to}
            to={link.to}
            className={({ isActive }) =>
              `flex items-center space-x-3 p-3 rounded-lg text-white text-base font-medium transition-all duration-200 ${
                isActive
                  ? 'bg-paragaiaLight text-paragaia'
                  : 'hover:bg-paragaiaLight hover:text-paragaia'
              }`
            }
          >
            {link.icon}
            <span>{link.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="p-4 border-t border-paragaiaLight">
        <button
          className="flex items-center space-x-3 p-3 w-full rounded-lg text-white text-base font-medium transition-all duration-200 hover:bg-paragaiaLight hover:text-paragaia"
          onClick={handleLogout}
        >
          <FiLogOut size={20} />
          <span>Déconnexion</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
